import { ANNOUNCEMENT_STATUS_LABELS, ORGANIZATION_STATUS_LABELS } from './utils'

import type {
  AnnouncementOrganizationStatusValue,
  AnnouncementStatus
} from '@/api/announcements-client'
import { cn } from '@/lib/utils'

const BASE =
  'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold'

const ANNOUNCEMENT_STATUS_CLASSES: Record<AnnouncementStatus, string> = {
  draft: 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-200',
  published:
    'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-100',
  archived: 'bg-zinc-200 text-zinc-600 dark:bg-zinc-800 dark:text-zinc-300'
}

const ORGANIZATION_STATUS_CLASSES: Record<
  AnnouncementOrganizationStatusValue,
  string
> = {
  acknowledged:
    'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-100',
  pending: 'bg-amber-100 text-amber-800 dark:bg-amber-900 dark:text-amber-100',
  expired: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-100',
  superseded:
    'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-200'
}

export const AnnouncementStatusBadge = ({
  status
}: {
  status?: AnnouncementStatus
}) =>
  status ? (
    <span className={cn(BASE, ANNOUNCEMENT_STATUS_CLASSES[status])}>
      {ANNOUNCEMENT_STATUS_LABELS[status] ?? status}
    </span>
  ) : null

export const OrganizationStatusBadge = ({
  status
}: {
  status?: AnnouncementOrganizationStatusValue
}) =>
  status ? (
    <span className={cn(BASE, ORGANIZATION_STATUS_CLASSES[status])}>
      {ORGANIZATION_STATUS_LABELS[status] ?? status}
    </span>
  ) : null
